
Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.CustomFilters = function () {

    this.fieldsOverride = {
        TAG: 'TAG_FILTER',
        PICKLIST_MULTISELECT: 'PICKLIST_MULTISELECT_FILTER',
        LOOKUP_LIST: 'POWER_LOOKUP_LIST_FILTER',
        TOGGLENUMBER: 'INTEGER',
        TEXT_AREA: 'TEXT'
    };

    this.setEntity = function (entity) {
        this.entity = entity;
    };

    this.setGridSelector = function (gridSelector) {
        this.gridSelector = gridSelector;
    };

    this.setSelector = function (selector) {
        this.selector = selector;
    };

    this.setElement = function (element) {
        this.element = element;
    };

    this.setScreenName = function (screenName) {
        this.screenName = screenName;
    };

    this.setCustomNameSpace = function (customNameSpace){
        this.customNameSpace = customNameSpace;
    };

    this.setFieldsOverride = function (fieldsOverride){
        this.fieldsOverride = Object.assign(this.fieldsOverride, fieldsOverride);
    };

    this.checkElementAndWriteHTML = function (element, html) {

        if (element !== null) {
            $(element).append(html);
        }

    };

    var retrieveDefaultFilters = function (entity){
        var defaultField = "";

        var dataMapper = App.Forms[entity].dataMapper;

        if(dataMapper.description) {
            defaultField = "description";
        } else if (dataMapper.key){
            defaultField = "key";
        } else if (dataMapper.name){
            defaultField = "name";
        }

        var obj = {};
        obj[defaultField] = {};
        obj[defaultField].value = "";

        return obj;

    };

    this.getProjection = function () {
        const { layout: { index: pageLayout }, customProjection } = App.Forms[this.entity];
        if (customProjection) {
            return JSON.stringify(customProjection);
        }

        const projectionBuilder = new Monet.Builder.Projection();
        if (pageLayout) {
            projectionBuilder.setLayout (pageLayout);
            projectionBuilder.parseLayout ();
            projectionBuilder.setPagination (App.Forms[this.entity].pagination);     
        }
        return projectionBuilder.projection.toString();
    };

    this.createFilterElement = function () {
        var filterBuilder = new Monet.UI.FilterBuilder();

        filterBuilder.setSelector (this.gridSelector);
        filterBuilder.setEntity (this.entity);
        filterBuilder.setFieldsOverride (this.fieldsOverride);
        filterBuilder.setCustomNameSpace (this.customNameSpace || this.entity);
        filterBuilder.setProjection(this.getProjection());
        filterBuilder.setDefaultFilters ( retrieveDefaultFilters(this.entity));

        filterBuilder.render ();

        filterBuilder.setCallbacks({
            success: function (context) {

                return function (data) {
                    context.updateGrid(context.entity, data);
                };

            }(this),
            error: this.filterErrorCallback

        });

        App.Forms[this.customNameSpace || this.entity].filterBuilder = filterBuilder;

        this.checkElementAndWriteHTML(
            this.element, filterBuilder.el
        );

        filterBuilder.postRender();

    };

    this.updateGrid = function(entity, collection) {

        var addPaginationGrid = true,
            tableLayout = Monet.Grid.getGridLayout(App.Forms[entity].layout.index),
            pagination = App.Forms[entity].pagination;

        if(pagination.first === 0){

            Monet.Grid.addDataToGrid(entity, tableLayout, collection, addPaginationGrid);

        } else {

            Monet.Grid.appendDataToGridAfterPagination(entity, tableLayout, collection);

        }

    };

    this.init = function () {

        if (!this.screenName) {
            this.screenName = Monet.Utils.GetTabName();
        }

        this.createFilterElement();

    };

};
